import React from 'react';
interface AdPlaceholderProps {
  width?: string;
  height?: string;
  text?: string;
  className?: string;
}
export function AdPlaceholder({
  width = 'w-full',
  height = 'h-24',
  text = 'Advertisement',
  className = ''
}: AdPlaceholderProps) {
  return <div className={`bg-gray-200 border border-gray-300 flex items-center justify-center text-gray-500 text-sm font-medium ${width} ${height} ${className} min-h-[50px]`} data-id="element-18">
      <span className="px-4 text-center" data-id="element-19">{text}</span>
    </div>;
}